import axios from "../axiosInstance";

class PlantService {
  async getPlantList() {
    return await axios.get("plant");
  }
}

export default new PlantService();
